import { render } from "./ButtonShowRound.vue?vue&type=template&id=bc8463a4&scoped=true"
import script from "./ButtonShowRound.vue?vue&type=script&lang=js"
export * from "./ButtonShowRound.vue?vue&type=script&lang=js"

import "./ButtonShowRound.vue?vue&type=style&index=0&id=bc8463a4&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc8463a4"]])

export default __exports__